if (typeof Box3D === "undefined") { throw new Error("babylon.box3d.js needs lib/umd/box3d.umd.js loaded first"); } export default Box3D;